import { useLocation } from "react-router";

// maybe this should be more generic "useIsUnauthenticatedPage" that checks for multiple routes (login, register, forgot-password) instead of just login and will tell if data queries can be enabled
export function useIsLoginPage() {
  const location = useLocation();
  return location.pathname === "/login";
}
